import React from "react";
import placeholderWarnImg from "../../../images/aiReport/placeholder-warn.svg";

export default ({  }) => {
    return (
        <div className='analysisContent_placeholder'>
            <img className="analysisContent_placeholder_img" src={placeholderWarnImg} />
            <p className="analysisContent_placeholder_title">很抱歉，您没有权限访问</p>
        </div>
    )
}